<mat-card class="analytics-card">
    <mat-card-header>
        <mat-card-title>Observation Analytics</mat-card-title>
        <mat-card-subtitle>Gain insights from observation data</mat-card-subtitle>
    </mat-card-header>
    
    <mat-card-content class="my-15">
        @if (errorMessage) {
            <div class="error-message p-15 my-15">
                <mat-icon class="valign-middle">error</mat-icon>
                <span class="ml-10">{{ errorMessage }}</span>
            </div>
        }

        @if (!loading && categories.length === 0) {
            <div class="no-data-alert p-30 text-center my-30">
                <mat-icon class="large-icon">analytics</mat-icon>
                <h3>No Observation Data Available</h3>
                <p>We couldn't find any 'final' observations with valid measurement values for this encounter.</p>
            </div>
        } @else {
            <div class="my-20">
                <mat-chip-listbox [value]="selectedCategory" (change)="selectCategory($event.value)" class="chip-list">
                    @for (category of categories; track category.code) {
                        <mat-chip-option [value]="category.code" [selected]="category.code === selectedCategory">
                            {{ category.display }}
                        </mat-chip-option>
                    }
                </mat-chip-listbox>
            </div>

            <div class="chart-container-wrapper">
                @if (loading) {
                    <div class="loading-overlay">
                        <mat-spinner diameter="40"></mat-spinner>
                        <span class="loading-text">Retrieving live encounter observations...</span>
                    </div>
                }

                <div class="chart-area my-30">
                    @if (chartFilterOptions.length > 0) {
                        <div class="pos-abs">
                            <select [formControl]="chartFilter" class="chart-filter">
                                @for (option of chartFilterOptions; track option.code) {
                                    <option [value]="option.code">{{ option.display }}</option>
                                }
                            </select>
                        </div>
                    }

                    @if (ngxChartData && ngxChartData[0]?.series?.length > 0) {
                        <ngx-charts-line-chart 
                            [autoScale]="true" 
                            [showGridLines]="true" 
                            [legendTitle]="legendTitle"
                            [legend]="false" 
                            [scheme]="colorScheme" 
                            [showXAxisLabel]="showXAxisLabel"
                            [showYAxisLabel]="showYAxisLabel" 
                            [xAxis]="xAxis" 
                            [yAxis]="yAxis" 
                            [xAxisLabel]="xAxisLabel"
                            [yAxisLabel]="yAxisLabel" 
                            [timeline]="timeline" 
                            [results]="ngxChartData">
                        </ngx-charts-line-chart>
                    } @else if (!loading) {
                        <div class="no-chart-data text-center">
                            <mat-icon>trending_flat</mat-icon>
                            <p>No historical trend data found for the selected observation.</p>
                        </div>
                    }
                </div>
            </div>
        }
    </mat-card-content>
</mat-card>